<div class="d-flex navigation-header">
  <h1 (click)="goBack()" id="panel">{{"admin.title" | translate }}</h1>
  <h1>&nbsp; > {{"admin.catalogs.title" | translate}}</h1>
</div>
<div class="container-card">

  <div class="container" (fileDropped)="onFileDropped($event)">
    <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event.target.files)" />
    <h3 style="margin-top: 40px;">{{"admin.catalogs.dropFile" | translate}}</h3>
    <h3>{{"admin.catalogs.or" | translate}}</h3>
    <label for="fileDropRef">{{"admin.catalogs.browse" | translate}}</label>
  </div>
  <div class="file-list">
    <div class="single-file" *ngIf="file">
      <div class="file-icon" style="width: 50px">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 58 58" style="enable-background:new 0 0 58 58;" xml:space="preserve">
          <polygon style="fill:#EDEADA;" points="51.5,14 37.5,0 6.5,0 6.5,58 51.5,58 " />
            <g>
              <path style="fill:#CEC9AE;" d="M16.5,23h25c0.552,0,1-0.447,1-1s-0.448-1-1-1h-25c-0.552,0-1,0.447-1,1S15.948,23,16.5,23z" />
              <path style="fill:#CEC9AE;" d="M16.5,15h10c0.552,0,1-0.447,1-1s-0.448-1-1-1h-10c-0.552,0-1,0.447-1,1S15.948,15,16.5,15z" />
              <path style="fill:#CEC9AE;" d="M41.5,29h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,29,41.5,29z" />
              <path style="fill:#CEC9AE;" d="M41.5,37h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,37,41.5,37z" />
              <path style="fill:#CEC9AE;" d="M41.5,45h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,45,41.5,45z" />
            </g>
          <polygon style="fill:#CEC9AE;" points="37.5,0 37.5,14 51.5,14 " />
			  </svg>
      </div>
      <div class="info">
        <h4 class="name">
          {{ file[0].name }}
        </h4>
        <p class="size">
          {{ formatBytes(file[0].size) }}
        </p>
      </div>
    </div>

    <mat-card *ngIf="loading" class="spinner-wrapper">
      <mat-progress-spinner class="spinner" color="primary" mode="indeterminate"></mat-progress-spinner>
    </mat-card>
  </div>

  <div *ngIf="!loading">
    <button [disabled]="!file" mat-flat-button color="primary" (click)="updateCatalog()" class="action-button" [ngClass]="(isEnglish()) ? 'action-button-en' : 'action-button-de'">
      {{'admin.catalogs.submit' | translate}}
    </button>
  </div>
</div>
